import {AbstractChartDTO} from './AbstractChartDTO';
import {TikTokPostDTO} from '../post/TikTokPostDTO';

export class TikTokPostChartDTO extends AbstractChartDTO {
  tikTokPostDTO: TikTokPostDTO;
}
